import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-error',
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  public loadingIndicator: boolean;

  constructor() { }

  ngOnInit(): void {
    this.loadingIndicator = false;
  }

}
